import { createContext, useContext, useEffect, useState } from "react";

import { request } from "@/lib/api";

const AdminAuthContext = createContext(null);

export function AdminAuthProvider({ children }) {
  const [token, setToken] = useState(() => window.localStorage.getItem("ivory_admin_access_token"));
  const [user, setUser] = useState(null);
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    async function loadProfile() {
      if (!token) {
        setIsChecking(false);
        return;
      }
      try {
        const profile = await request("/admin/auth/me", {}, token);
        setUser(profile);
      } catch {
        window.localStorage.removeItem("ivory_admin_access_token");
        setToken(null);
      } finally {
        setIsChecking(false);
      }
    }
    loadProfile();
  }, [token]);

  async function sendOtp(email) {
    return request("/admin/auth/request-otp", { method: "POST", body: JSON.stringify({ email }) });
  }

  async function sendMobileOtp(mobile) {
    return request("/admin/auth/request-mobile-otp", { method: "POST", body: JSON.stringify({ mobile }) });
  }

  async function verifyMobileOtp(mobile, otp) {
    const result = await request("/admin/auth/verify-mobile-otp", { method: "POST", body: JSON.stringify({ mobile, otp }) });
    window.localStorage.setItem("ivory_admin_access_token", result.access_token);
    setToken(result.access_token);
    setUser(result.user);
    return result;
  }

  async function verifyOtp(email, otp) {
    const result = await request("/admin/auth/verify-otp", { method: "POST", body: JSON.stringify({ email, otp }) });
    window.localStorage.setItem("ivory_admin_access_token", result.access_token);
    setToken(result.access_token);
    setUser(result.user);
    return result;
  }

  function signOut() {
    window.localStorage.removeItem("ivory_admin_access_token");
    setToken(null);
    setUser(null);
  }

  return <AdminAuthContext.Provider value={{ token, user, isChecking, sendOtp, verifyOtp, sendMobileOtp, verifyMobileOtp, signOut }}>{children}</AdminAuthContext.Provider>;
}

export function useAdminAuth() {
  const context = useContext(AdminAuthContext);
  if (!context) {
    throw new Error("useAdminAuth must be used within AdminAuthProvider.");
  }
  return context;
}
